module.exports = __webpack_public_path__ + "static/img/bannerstore.5601633.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store/bannerstore.png
// module id = Tbth
// module chunks = 0